import css from './CustomHtml.module.css'

export function CustomHtml({ html }: { html: string }) {
    return <div className={css.customHtml} dangerouslySetInnerHTML={{ __html: html }} />
}
